module.exports = __webpack_public_path__ + "static/media/gewinnspiel2021.38422a2f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gewinnspiel2021.jpg
// module id = 109
// module chunks = 0